// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  display: flex;
  flex-direction: column;
  background-color: rgb(248, 248, 255);
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  font-family: PlusJakartaSans;
}

.profile-title,
.client-container,
.user-table-container {
  display: flex;
  width: 100%;
  border-radius: 0.5rem;

}

.profile-title {
  padding: 2rem 0;
  padding-top: 0.75rem;
}

.client-container {
  padding: 1.25rem 1rem;
  background-color: white;
  margin-bottom: 1rem;
}

.profile-title-text {
  font-family: PlusJakartaSans;
  font-size: 18px;
  font-weight: 400;
  font-size: 1.5rem;
  font-weight: 600;
}

.client-container-in {
  display: flex;
  /* width: 25%; */
  gap:1rem;
  background-color: white;
  align-items: center;
  justify-content: space-between;

}

.client-logo {
  height: 3rem;
  width: 3rem;
}

.client-details-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.client-name-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.25rem;
  height: 2.35rem;
}

.profile-client-label {
  color: rgb(172, 182, 192);
  margin-bottom:0;
}

.profile-client-span {
  color: rgb(69, 79, 91);
  font-weight: 600;
}

.client-logo-in-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgb(236, 236, 254);
  padding: 0.25rem;
  width: 2.35rem;
  height: 2.35rem;
}

.profile-user-icon {
  height: 1.5rem;
  width: 1.5rem;
  color: rgb(102, 102, 245);
}

.client-duration-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.profile-calender-icon {
  height: 1.25rem;
  width: 1.5rem;
  color: rgb(102, 102, 245);
}

.user-table-container {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  gap: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
  background-color: white;
}

.user-table {
  display: grid;
  width: 100%;
  border-collapse: collapse;
  border-radius: 0.5rem;
}

.user-row {
  display: grid;
  grid-template-columns: 0.5fr 1fr 0.5fr;
  align-items: center;
  border: 1px solid rgb(246, 248, 249);
  padding: 0.5rem 0;
}

.user-table-header {
  display: grid;
  grid-template-columns: 0.5fr 1fr 0.5fr;
  align-items: center;
  justify-content: flex-start;
  background-color: rgb(244, 246, 248);
  padding: 0.5rem;
  padding: 0.5rem;
  font-weight: 600;
  color: rgb(69, 79, 91);
}

.user-table-title {
  font-size: 1.125rem;
  font-weight: 600;
}

.user-table-header span {
  padding-left: 0.5rem;
  font-family: "PlusJakartaSans";
}

.user-row {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.user-row>div {
  padding: 0.5rem;
  color: rgb(46, 56, 67);
  font-weight: 500;
}

.action {
  display: flex;
  justify-content:flex-end ;
  align-items: center;
  /* padding: 0.5rem; */
}

.action-span {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right:1rem;
  }

.profile-table-in-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 0.5rem; */
  background-color: transparent;
  border: none;
}

.profile-table-in-icon {
  height: 1.5rem;
  width: 1.5rem;
  color: rgb(145, 158, 171);
  /* fill: rgb(145, 158, 171); */
}

.profile-table-in-btn:hover:not([disabled]) .profile-table-in-icon {
  color: black;
  /* Optionally, change the color of the icon when hovered */
}

.profile-table-in-btn[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
  /* Adjust opacity to visually indicate the button is disabled */
}

.profile-table-in-btn[disabled] .profile-table-in-icon {
  /* Optionally, you can apply additional styling to the icon inside the button when disabled */
  color: #ccc;
  /* Example: change the color of the icon */
}
.popup-root {
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-overlay {
  width: 100vw;
  height: 100vh;
  display: flex;
  margin: 0;
}

.profile-popup-content {
  display: flex;
  align-items: center;
  align-self: center;
  background-color: white;
  width: 22%;
  font-family: 'PlusJakartaSans';
  border-radius:0.25rem;
  /* padding:1rem;
  padding-top:0; */
}

.edit-popup-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  background-color: white;
  width: 100%;
  border-radius: 0.5rem;
}

.edit-popup-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: rgb(13, 13, 47);
  color: white;
  /* height: 2rem; */
  padding: 1rem;
  font-size: large;
}

.edit-popup-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: medium;
  color:rgb(95, 99, 103);
  border-radius:0.25;
}

.edit-popup-item-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;
}

.edit-popup-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0.5rem;
  height: 2rem;
  border-radius: 0.25rem;
  border: 2px solid rgb(64, 64, 242);
  color: rgb(64, 64, 242);
  background-color: white;
}

.edit-popup-btn:hover {
  background-color: rgb(64, 64, 242) !important;
  color: white;
}

.edit-popup-content-input {
  width: 100%;
  height: 2rem;
  border-radius: 0.125rem;
  border:1px solid rgb(240, 240, 240);
  ;
}

.edit-popup-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  font-size: large;
}

[role=tooltip].popup-content {
  width: 400px;
  box-shadow: 0 0 3px rgba(0, 0, 0, .16);
  border-radius:0.25;
}

.popup-overlay {
  background: rgba(0, 0, 0, .5)
}

[data-popup=tooltip].popup-overlay {
  background: transparent
}

.center-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.delete-popup-span{
  font-size:medium;
  line-height: 1.5rem;
}
.delete-popup-span-name{
  font-weight:bold;
}

@media only screen and (max-width: 1281px) and (min-width: 720px) {
  .client-container {
    font-size: small;
  }

  .user-table-container {
    font-size: small;
  }

  .client-container-in {
    font-size: small;
    width: 35%;
  }

  .action-span {
    margin-right: 0.5rem;
  }

  .profile-title-text {
    font-size: large;
  }

  .profile-client-label,
  .profile-client-span {
    font-size: small;
  }

  .client-container-in {
    font-size: medium;
    width: 50%;
  }

  .user-row>div {
    font-size: small;
  }

  .user-table-header {
    font-size: small;
  }
  .action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* padding: 0.5rem; */
  }
  .profile-popup-content {
    width: 30%;
  }
  .delete-popup-span{
    font-size:small;
    line-height: 1.5rem;
  }
  .profile-table-in-icon {
    height: 1rem;
    width: 1rem;
  }

}

@media only screen and (max-width: 1650px) and (min-width: 1282px) {
  .action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* padding: 0.5rem; */
  }
  .action-span {
    margin-right: 0.8rem;
  }

  .profile-title-text {
    font-size: large;
  }

  .profile-client-label,
  .profile-client-span {
    font-size: small;
  }

  .client-container-in {
    font-size: medium;
    width: 35%;
  }

  .user-row>div {
    font-size: small;
  }

  .user-table-header {
    font-size: medium;
  }
  .profile-popup-content{
    width: 30%;
  }
  .delete-popup-span{
    font-size:small;
    line-height: 1.5rem;
  }
  .profile-table-in-icon {
    height: 1.25rem;
    width: 1.25rem;
    color: rgb(145, 158, 171);
  }

}



@media only screen and (max-width: 719px) and (min-width: 300px) {
  .action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* padding: 0.5rem; */
  }
  .action-span {
    margin-right: 1rem;
    margin-left:0;
  }

  .profile-title-text {
    font-size: medium;
  }

  .profile-client-label,
  .profile-client-span {
    font-size: x-small;
  }

  .client-container-in {
    font-size: small;
    /* width: 50%; */
  }

  .user-row>div {
    font-size: x-small;
  }

  .user-table-header {
    font-size: small;
  }
  .profile-popup-content{
    width: 50%;
  }
  .delete-popup-span{
    font-size:smaller;
    line-height: 1.5rem;
  }
  .profile-table-in-icon {
    height: 1rem;
    width: 1rem;
    color: rgb(145, 158, 171);
  }

}
@media only screen and (max-height: 700px) and (min-height: 300px) {

  
  }
  @media only screen and (max-width: 1900px) and (min-width: 1700px) {
    .action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      /* padding: 0.5rem; */
    }
    .action-span {
      margin-right: 1.8rem;
    }
  
  

  


  



  
  }`, "",{"version":3,"sources":["webpack://./src/pages/Profile/Profile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;EAGE,aAAa;EACb,WAAW;EACX,qBAAqB;;AAEvB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;;AAEhC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;EACnB;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,+DAA+D;AACjE;;AAEA;EACE,6FAA6F;EAC7F,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,8BAA8B;EAC9B,qBAAqB;EACrB;kBACgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;;AAErC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,cAAc;IACd,yBAAyB;EAC3B;;AAEF;;;;AAIA;EACE;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;AAEF;AACA;;;EAGE;EACA;IACE;MACE,aAAa;MACb,yBAAyB;MACzB,mBAAmB;MACnB,qBAAqB;IACvB;IACA;MACE,oBAAoB;IACtB;;;;;;;;;;;;EAYF","sourcesContent":[".profile-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: rgb(248, 248, 255);\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 1.25rem;\r\n  font-family: PlusJakartaSans;\r\n}\r\n\r\n.profile-title,\r\n.client-container,\r\n.user-table-container {\r\n  display: flex;\r\n  width: 100%;\r\n  border-radius: 0.5rem;\r\n\r\n}\r\n\r\n.profile-title {\r\n  padding: 2rem 0;\r\n  padding-top: 0.75rem;\r\n}\r\n\r\n.client-container {\r\n  padding: 1.25rem 1rem;\r\n  background-color: white;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.profile-title-text {\r\n  font-family: PlusJakartaSans;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.client-container-in {\r\n  display: flex;\r\n  /* width: 25%; */\r\n  gap:1rem;\r\n  background-color: white;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n\r\n}\r\n\r\n.client-logo {\r\n  height: 3rem;\r\n  width: 3rem;\r\n}\r\n\r\n.client-details-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.client-name-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  gap: 0.25rem;\r\n  height: 2.35rem;\r\n}\r\n\r\n.profile-client-label {\r\n  color: rgb(172, 182, 192);\r\n  margin-bottom:0;\r\n}\r\n\r\n.profile-client-span {\r\n  color: rgb(69, 79, 91);\r\n  font-weight: 600;\r\n}\r\n\r\n.client-logo-in-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  background-color: rgb(236, 236, 254);\r\n  padding: 0.25rem;\r\n  width: 2.35rem;\r\n  height: 2.35rem;\r\n}\r\n\r\n.profile-user-icon {\r\n  height: 1.5rem;\r\n  width: 1.5rem;\r\n  color: rgb(102, 102, 245);\r\n}\r\n\r\n.client-duration-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.profile-calender-icon {\r\n  height: 1.25rem;\r\n  width: 1.5rem;\r\n  color: rgb(102, 102, 245);\r\n}\r\n\r\n.user-table-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* align-items: center; */\r\n  gap: 1rem;\r\n  border-radius: 0.5rem;\r\n  padding: 1rem;\r\n  background-color: white;\r\n}\r\n\r\n.user-table {\r\n  display: grid;\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.user-row {\r\n  display: grid;\r\n  grid-template-columns: 0.5fr 1fr 0.5fr;\r\n  align-items: center;\r\n  border: 1px solid rgb(246, 248, 249);\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.user-table-header {\r\n  display: grid;\r\n  grid-template-columns: 0.5fr 1fr 0.5fr;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  background-color: rgb(244, 246, 248);\r\n  padding: 0.5rem;\r\n  padding: 0.5rem;\r\n  font-weight: 600;\r\n  color: rgb(69, 79, 91);\r\n}\r\n\r\n.user-table-title {\r\n  font-size: 1.125rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.user-table-header span {\r\n  padding-left: 0.5rem;\r\n  font-family: \"PlusJakartaSans\";\r\n}\r\n\r\n.user-row {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n}\r\n\r\n.user-row>div {\r\n  padding: 0.5rem;\r\n  color: rgb(46, 56, 67);\r\n  font-weight: 500;\r\n}\r\n\r\n.action {\r\n  display: flex;\r\n  justify-content:flex-end ;\r\n  align-items: center;\r\n  /* padding: 0.5rem; */\r\n}\r\n\r\n.action-span {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    margin-right:1rem;\r\n  }\r\n\r\n.profile-table-in-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* padding: 0.5rem; */\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.profile-table-in-icon {\r\n  height: 1.5rem;\r\n  width: 1.5rem;\r\n  color: rgb(145, 158, 171);\r\n  /* fill: rgb(145, 158, 171); */\r\n}\r\n\r\n.profile-table-in-btn:hover:not([disabled]) .profile-table-in-icon {\r\n  color: black;\r\n  /* Optionally, change the color of the icon when hovered */\r\n}\r\n\r\n.profile-table-in-btn[disabled] {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  /* Adjust opacity to visually indicate the button is disabled */\r\n}\r\n\r\n.profile-table-in-btn[disabled] .profile-table-in-icon {\r\n  /* Optionally, you can apply additional styling to the icon inside the button when disabled */\r\n  color: #ccc;\r\n  /* Example: change the color of the icon */\r\n}\r\n.popup-root {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.popup-overlay {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  margin: 0;\r\n}\r\n\r\n.profile-popup-content {\r\n  display: flex;\r\n  align-items: center;\r\n  align-self: center;\r\n  background-color: white;\r\n  width: 22%;\r\n  font-family: 'PlusJakartaSans';\r\n  border-radius:0.25rem;\r\n  /* padding:1rem;\r\n  padding-top:0; */\r\n}\r\n\r\n.edit-popup-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  align-self: center;\r\n  background-color: white;\r\n  width: 100%;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.edit-popup-title {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  background-color: rgb(13, 13, 47);\r\n  color: white;\r\n  /* height: 2rem; */\r\n  padding: 1rem;\r\n  font-size: large;\r\n}\r\n\r\n.edit-popup-content {\r\n  padding: 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  font-size: medium;\r\n  color:rgb(95, 99, 103);\r\n  border-radius:0.25;\r\n}\r\n\r\n.edit-popup-item-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.edit-popup-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  padding: 0.5rem;\r\n  height: 2rem;\r\n  border-radius: 0.25rem;\r\n  border: 2px solid rgb(64, 64, 242);\r\n  color: rgb(64, 64, 242);\r\n  background-color: white;\r\n}\r\n\r\n.edit-popup-btn:hover {\r\n  background-color: rgb(64, 64, 242) !important;\r\n  color: white;\r\n}\r\n\r\n.edit-popup-content-input {\r\n  width: 100%;\r\n  height: 2rem;\r\n  border-radius: 0.125rem;\r\n  border:1px solid rgb(240, 240, 240);\r\n  ;\r\n}\r\n\r\n.edit-popup-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  width: 100%;\r\n  padding: 1rem;\r\n  font-size: large;\r\n}\r\n\r\n[role=tooltip].popup-content {\r\n  width: 400px;\r\n  box-shadow: 0 0 3px rgba(0, 0, 0, .16);\r\n  border-radius:0.25;\r\n}\r\n\r\n.popup-overlay {\r\n  background: rgba(0, 0, 0, .5)\r\n}\r\n\r\n[data-popup=tooltip].popup-overlay {\r\n  background: transparent\r\n}\r\n\r\n.center-popup {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.delete-popup-span{\r\n  font-size:medium;\r\n  line-height: 1.5rem;\r\n}\r\n.delete-popup-span-name{\r\n  font-weight:bold;\r\n}\r\n\r\n@media only screen and (max-width: 1281px) and (min-width: 720px) {\r\n  .client-container {\r\n    font-size: small;\r\n  }\r\n\r\n  .user-table-container {\r\n    font-size: small;\r\n  }\r\n\r\n  .client-container-in {\r\n    font-size: small;\r\n    width: 35%;\r\n  }\r\n\r\n  .action-span {\r\n    margin-right: 0.5rem;\r\n  }\r\n\r\n  .profile-title-text {\r\n    font-size: large;\r\n  }\r\n\r\n  .profile-client-label,\r\n  .profile-client-span {\r\n    font-size: small;\r\n  }\r\n\r\n  .client-container-in {\r\n    font-size: medium;\r\n    width: 50%;\r\n  }\r\n\r\n  .user-row>div {\r\n    font-size: small;\r\n  }\r\n\r\n  .user-table-header {\r\n    font-size: small;\r\n  }\r\n  .action {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    /* padding: 0.5rem; */\r\n  }\r\n  .profile-popup-content {\r\n    width: 30%;\r\n  }\r\n  .delete-popup-span{\r\n    font-size:small;\r\n    line-height: 1.5rem;\r\n  }\r\n  .profile-table-in-icon {\r\n    height: 1rem;\r\n    width: 1rem;\r\n  }\r\n\r\n}\r\n\r\n@media only screen and (max-width: 1650px) and (min-width: 1282px) {\r\n  .action {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    /* padding: 0.5rem; */\r\n  }\r\n  .action-span {\r\n    margin-right: 0.8rem;\r\n  }\r\n\r\n  .profile-title-text {\r\n    font-size: large;\r\n  }\r\n\r\n  .profile-client-label,\r\n  .profile-client-span {\r\n    font-size: small;\r\n  }\r\n\r\n  .client-container-in {\r\n    font-size: medium;\r\n    width: 35%;\r\n  }\r\n\r\n  .user-row>div {\r\n    font-size: small;\r\n  }\r\n\r\n  .user-table-header {\r\n    font-size: medium;\r\n  }\r\n  .profile-popup-content{\r\n    width: 30%;\r\n  }\r\n  .delete-popup-span{\r\n    font-size:small;\r\n    line-height: 1.5rem;\r\n  }\r\n  .profile-table-in-icon {\r\n    height: 1.25rem;\r\n    width: 1.25rem;\r\n    color: rgb(145, 158, 171);\r\n  }\r\n\r\n}\r\n\r\n\r\n\r\n@media only screen and (max-width: 719px) and (min-width: 300px) {\r\n  .action {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    /* padding: 0.5rem; */\r\n  }\r\n  .action-span {\r\n    margin-right: 1rem;\r\n    margin-left:0;\r\n  }\r\n\r\n  .profile-title-text {\r\n    font-size: medium;\r\n  }\r\n\r\n  .profile-client-label,\r\n  .profile-client-span {\r\n    font-size: x-small;\r\n  }\r\n\r\n  .client-container-in {\r\n    font-size: small;\r\n    /* width: 50%; */\r\n  }\r\n\r\n  .user-row>div {\r\n    font-size: x-small;\r\n  }\r\n\r\n  .user-table-header {\r\n    font-size: small;\r\n  }\r\n  .profile-popup-content{\r\n    width: 50%;\r\n  }\r\n  .delete-popup-span{\r\n    font-size:smaller;\r\n    line-height: 1.5rem;\r\n  }\r\n  .profile-table-in-icon {\r\n    height: 1rem;\r\n    width: 1rem;\r\n    color: rgb(145, 158, 171);\r\n  }\r\n\r\n}\r\n@media only screen and (max-height: 700px) and (min-height: 300px) {\r\n\r\n  \r\n  }\r\n  @media only screen and (max-width: 1900px) and (min-width: 1700px) {\r\n    .action {\r\n      display: flex;\r\n      justify-content: flex-end;\r\n      align-items: center;\r\n      /* padding: 0.5rem; */\r\n    }\r\n    .action-span {\r\n      margin-right: 1.8rem;\r\n    }\r\n  \r\n  \r\n\r\n  \r\n\r\n\r\n  \r\n\r\n\r\n\r\n  \r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
